import script from "./Desktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./Desktop.vue?vue&type=script&setup=true&lang=ts"

import "./Desktop.vue?vue&type=style&index=0&id=324d1762&scoped=true&lang=css"
import "./Desktop.vue?vue&type=style&index=1&id=324d1762&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324d1762"]])

export default __exports__